import React from 'react';
import { Form, Input, Button,Spin,DatePicker, message,Card,Result } from 'antd';
import axios from 'axios'
import * as serverconfig from '../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,UploadOutlined } from '@ant-design/icons';

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const dateFormat = 'DD/MM/YYYY';
const { RangePicker } = DatePicker;


var token= ''
var sacco= ''


class LoanDateUpdateForm extends React.Component {

  state = {
    idtypeName:'' ,  
    idtypeDescription:'',
    datarequested:false,
    current_txn_date:'',
    datasubmittedsuccessfully:false,
    message:''
 
  }

  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
    }else{
       sacco= ''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }
  }



  render(){

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{

      if(this.state.datasubmittedsuccessfully===true){
        return (

        <Card>
        <Result
        status="success"
        title="Successfully updated "
        subTitle={this.state.message}
        extra={[
          <Button  type='primary' onClick={()=>{window.location.reload(false)}}>Finish</Button>,
        ]}
        />
        </Card>
        )

      }else{

        return (
          <div>
  
      <Form >
       
            <FormItem label={"Select date"}>
              <DatePicker onChange={(date, dateString)=>{this.setState({ current_txn_date: dateString})}} format={dateFormat} />
            </FormItem>
  
            <Button type='primary' key="back" onClick={()=>{
              if (this.state.current_txn_date===""){
                message.error("Please select date")
              }else{
  
              //make qery now
              let form_data = new FormData();
              form_data.append('current_selected_loan',this.props.current_selected_loan);
              form_data.append('current_txn_date', this.state.current_txn_date);
              form_data.append('sacco',sacco);
  
              this.setState({datarequested:true})
  
              axios.post(serverconfig.backendserverurl+'/customqueries/confirmloan_date_update', form_data,{
                headers: {
                  'content-type': 'multipart/form-data'
                } })
              .then(res => {
                this.setState({datarequested:false})
                this.setState({message:res.data.message})
                this.setState({datasubmittedsuccessfully:true})
  
  
              })
              .catch(error => console.log(error))
              }
  
            }}>
            Update issuance date 
            </Button>
  
       </Form>
          </div>
        );
  
      }

    }

  }

}


export default LoanDateUpdateForm;



